import { cn } from "@/lib/utils";

export default function ButtonMain({ children, onClick, type = "button", disabled, className = "", full = false }) {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-lg bg-brand-primary px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brand-primary-hover active:bg-brand-primary-hover disabled:cursor-not-allowed disabled:opacity-50",
        full && "w-full",
        className
      )}
    >
      {children}
    </button>
  );
}
